import moment from 'moment';

const MIN_DATE = moment('2022-12-20');

const SEARCH_OPTIONS_SCHEMA = {
  startDate: moment(),
  endDate: moment(),
  startTime: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  endTime: moment().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }),
  pickUp: true,
  dropOff: true,
  error: false,
  appt: false,
  carr: '',
  carrCheck: true,
  fwd_id: 0,
  trk_cmp: 0,
  drv_name: '',
  scr_name: '',
  gha_id: 0,
  entity: 'forwarder',
  rank_by: 'wgt',
  report: 'awbs'
};

const QUERY_OPTIONS_SCHEMA = {
  type: 'AWBS',
  cmp: 'GT',
  value: 0
};

const CUSTOMER_WAIT_GRAPH_SCHEMA = {
  orders: [],
  cont_wait: [],
  cont_pros: [],
  whse_wait: [],
  whse_pros: [],
};

const CUSTOMER_WAIT_AVERAGE_SCHEMA = {
  cont_wait: 0,
  cont_pros: 0,
  whse_wait: 0,
  whse_pros: 0,
  total: 0,
  long_time: 0,
  short_time: 0,
  awb_min: 0,
  awb_avg: 0,
  awb_max: 0,
  pcs_min: 0,
  pcs_max: 0,
  pcs_avg: 0,
  wgt_min: 0,
  wgt_max: 0,
  wgt_avg: 0,
};

const SCREENING_MEASURES_COLOR: { [key: string]: string } = {
  'Screened': '#00325E',
  'Exemption': '#FFC001',
  'Alternative Screening': '#70AD47',
  'Exemption Domestic Cargo': '#AAAAAA',
  'Exemption International Cargo': '#8c03fc',
  'No Chain of Custody': '#1fbcdb',
  'Other': '#D9001B'
}

const SCREENING_METHOD_CODES: { [key: string]: { code: string; text: string } } = {
  'X-Ray': { code: 'XRY', text: 'Xray' },
  'ETD': { code: 'ETD', text: 'Explosive Trace Detection' },
  'Physical': { code: 'PHY', text: 'Physical Search' },
  'K9': { code: 'EDD', text: 'Explosive Detection Dogs (K9)' },
  'CCSF': { code: 'CSF', text: 'CCSF Prescreened' },
  'Received screened from Interline': { code: 'RCI', text: 'Received Screened From Interline' },
  'Screened at origin and arrived with proper chain of custody': { code: 'RCO', text: 'Received Screened From Origin (Transfer Cargo)' },
  'Medical Shipments (18.3.6.1)': { code: 'MED', text: 'Medical Shipments' },
  'Human Remains (18.3.6.2)': { code: 'HUM', text: 'Human Remains' },
  'Live Animals (18.3.6.3) ': { code: 'AVI', text: 'Live Animals' },
  'Hazmat (18.3.6.4)': { code: 'DGR', text: 'Hazmat' },
  'Federal Reserve (18.3.6.5)': { code: 'FED', text: 'Federal Reserve' },
  'Dept Of Defence (18.3.6.3)': { code: 'DOD', text: 'Dept Of Defence' },
  'US CBP Orders Of Export (18.3.6.7)': { code: 'CBP', text: 'US CBP Orders Of Export' },
  'US Law Enforcement (18.3.6.8)': { code: 'LEO', text: 'US Law Enforcement' },
  'Diplomatic Pouches (17.2) ': { code: 'DIP', text: 'Diplomatic Pouches' },
  'Items with 68kg or less': { code: 'L68', text: 'Items with 68kg or less' },
  'Locked hard sided ULD container': { code: 'LUC', text: 'Locked hard sided ULD container' },
  'Banded in a skid on all four sides': { code: 'BND', text: 'Banded in a skid on all 4 sides' },
  'HAZMAT': { code: 'DGR', text: 'HAZMAT' },
  'Items can only be opened from outside': { code: 'OFO', text: 'Items can only be opened from outside' },
  'Human organs, human blood and by products': { code: 'LHO', text: 'Human organs, human blood and by products' },
  'Emergency life saving drugs drugs': { code: 'ELS', text: 'Emergency life saving drugs drugs' },
  'Emergency life saving drugs': { code: 'ELS', text: 'Emergency life saving drugs drugs' },
  'Human Remains': { code: 'HUM', text: 'Human Remains' },
  'Lower Deck Cargo': { code: 'LDC', text: 'Lower Deck Cargo' },
  'Federal Reserve / US Treasury sealed': { code: 'FED', text: 'Federal Reserve, US Treasury sealed' },
  'Cargo that cannot have a person Inside': { code: 'NPI', text: 'Cargo that cannot have a person Inside' },
  'Department of defence': { code: 'DOD', text: 'Department of defence' },
  'Hazmat (18.3.6.4': { code: 'DGR', text: 'Hazmat' },
  'Federal Reserve shipment (18.3.6.5)': { code: 'FED', text: 'Federal Reserve shipment' },
  'Dept Of Defense (18.3.6.3)': { code: 'DOD', text: 'Department of defence' },
  'Human organs/specimens (18.5.5.1)': { code: 'LHO', text: 'Human organs/specimens' },
  'Live Animals': { code: 'AVI', text: 'Live Animals' },
  'Federal reserve/US treasury sealed': { code: 'FED', text: 'Federal reserve / US treasury sealed' },
  'Cargo that cannot have a person inside': { code: 'NPI', text: 'Cargo that cannot have a person inside' },
  'ITS Impractical to Screen': { code: 'ITS', text: 'ITS Impractical to Screen' },
  'Single Entity Charter': { code: 'SEC', text: 'Single Entity Charter' },
  'CCSF freight with proper chain of custody (8.3.3)': { code: 'CSF', text: 'CCSF freight with proper chain of custody' },
  'Interline transfers with proper chain of custody': { code: 'ITL', text: 'Interline transfers with proper chain of custody' },
  'K9 not conducted': { code: 'EDD', text: 'K9 not conducted' },
  'Pre-Screened RFS transfers': { code: 'RFS', text: 'Pre-Screened RFS transfers' },
  'COMAT': { code: 'CDM', text: 'COMAT' },
}


export {
  SEARCH_OPTIONS_SCHEMA,
  QUERY_OPTIONS_SCHEMA,
  CUSTOMER_WAIT_GRAPH_SCHEMA,
  CUSTOMER_WAIT_AVERAGE_SCHEMA,
  MIN_DATE,
  SCREENING_MEASURES_COLOR,
  SCREENING_METHOD_CODES
};